import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import axios from 'axios';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { BaseLoader } from 'views/UIWidgets';
import {
	Card,
	CardActions,
	CardHeader,
	CardContent,
	Button,
	Divider,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { StatusBullet } from '../../../../components';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100%',
	},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 800,
	},
	statusContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	status: {
		marginRight: theme.spacing(1),
	},
	actions: { justifyContent: 'flex-end' },
}));

const LatestOrders = props => {
	const { className, history, staticContext, ...rest } = props;

	const classes = useStyles();

	const [orders, setOrders] = useState([]);

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchOrders = async () => {
			setLoading(true);
			axios
				.get('/orders/all', {
					params: {
						currentPage: 1,
						numberPerPage: 6,
					},
				})
				.then(result => {
					setLoading(false);
					setOrders(result.data.content.orders);
				})
				.catch(error => {
					setLoading(false);
					console.log(error);
				});
		};
		fetchOrders();
	}, []);

	const returnOrderStatusColor = status => {
		switch (status) {
			case '待发货':
				return 'warning';
			case '已签收':
				return 'success';
			default:
				return 'primary';
		}
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title='订单列表' />
			<Divider />
			<CardContent className={classes.content}>
				<PerfectScrollbar>
					{loading ? (
						<BaseLoader />
					) : (
						<div className={classes.inner}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>日期</TableCell>
										<TableCell>内容</TableCell>
										<TableCell>金额</TableCell>
										<TableCell>状态</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{orders.map(order => (
										<TableRow hover key={order._id}>
											<TableCell>
												{moment(order.date).format('DD/MM/YYYY HH:mm')}
											</TableCell>
											<TableCell>{order.selectedItems[0].name} 等</TableCell>
											<TableCell>${order.totalPrice}</TableCell>
											<TableCell>
												<div className={classes.statusContainer}>
													<StatusBullet
														className={classes.status}
														color={returnOrderStatusColor(order.status)}
														size='sm'
													/>
													{order.status}
												</div>
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</div>
					)}
				</PerfectScrollbar>
			</CardContent>
			<Divider />
			<CardActions className={classes.actions}>
				<Button
					color='primary'
					style={{ height: '100%' }}
					size='small'
					variant='text'
					onClick={() => {
						history.push('/orders');
					}}
				>
					查看全部 <ArrowRightIcon />
				</Button>
			</CardActions>
		</Card>
	);
};

LatestOrders.propTypes = {
	className: PropTypes.string,
};

export default withRouter(LatestOrders);
